import { render, staticRenderFns } from "./SaleEditAwsDocuments.vue?vue&type=template&id=3f618cc2&scoped=true"
import script from "./SaleEditAwsDocuments.vue?vue&type=script&lang=ts"
export * from "./SaleEditAwsDocuments.vue?vue&type=script&lang=ts"
import style0 from "./SaleEditAwsDocuments.vue?vue&type=style&index=0&id=3f618cc2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f618cc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f618cc2')) {
      api.createRecord('3f618cc2', component.options)
    } else {
      api.reload('3f618cc2', component.options)
    }
    module.hot.accept("./SaleEditAwsDocuments.vue?vue&type=template&id=3f618cc2&scoped=true", function () {
      api.rerender('3f618cc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleEditAwsDocuments.vue"
export default component.exports